import './base_integration.js.coffee';# Added by Script 
Namespace 'Customer.Ticket.Integration'

class Customer.Ticket.Integration.Salesforce extends Customer.Ticket.Integration.BaseIntegration

  onClickExternalCrm: (profile_id) =>
    @showLoadingAnimation()
    $.ajax
      type: 'POST'
      url: "/customer/conversations/search_contacts/#{@ticket.id}"
      data: {profile_id: profile_id, identifier: @_identifier()}
      success: @_onSearchContactsSuccess
      error: @_onSearchContactsError

  exportToCrm: (profile_id, contact_id) =>
    @showLoadingAnimation()
    $.ajax
      type: 'POST'
      url: "/customer/conversations/export_to_crm/#{@ticket.id}"
      data: {profile_id: profile_id, identifier: @_identifier(), contact_id: contact_id}
      success: @_onSuccess
      error: @_onRequestError

  _identifier: ->
    'salesforce'

  _onSearchContactsSuccess: (response) =>
    @hideLoadingAnimation()
    @trigger('ticket:searchcontacts:success', response.result)

  _onSearchContactsError: (response) =>
    @_onErrorAlert(response)
    @hideLoadingAnimation()
